import { Outlet } from "react-router";
import Header from "../../component/layout/header";
import useNav from "../../script/tabingNavArray";

const ClientHealthLayout = () => {
  const navList = useNav();
  let { clientHealthBottomHeader, clientHealthTopHeader } = navList;
  return (
    <div className="webBody">
      <Header
        bottomTabs={clientHealthBottomHeader}
        topTabs={clientHealthTopHeader}
      />
      <Outlet />
    </div>
  );
};

export default ClientHealthLayout;
